import { Slider } from "@nextui-org/react";
import React, { useEffect, useState } from "react";

const Size = ({ onChange }) => {
  const [value, setValue] = useState(7972.5);
  const [circlesize, setCircleSize] = useState(100);
  const [earthSize, setEarthSize] = useState(80);
  const [showText, setShowText] = useState(false);

  function changeSizeACB(value) {
    if (isNaN(Number(value))) return;
    setValue(value);
    if (value < 12756) {
      //before maximum height of circle
      setCircleSize(calculateConvertedValueCircle(value));
      if (earthSize < 80) setEarthSize(calculateEarthSize(value));
    }
    if (value > 12756) {
      //after maximum height of circle
      setEarthSize(calculateEarthSize(value));
    }

    function calculateConvertedValueCircle(value) {
      //convert km to px of the circle
      const convertedValue = (value * 160) / 12756;
      return Math.max(convertedValue, 0);
    }
    function calculateEarthSize(value) {
      //convert km to px of the earth considering the ratio
      let newvalue = 6236 / value;
      const convertedValue = circlesize * newvalue;
      return Math.max(convertedValue, 0);
    }
  }

  function calculateRatio() {
    //calculate the ratio of the circle and the earth
    const ratio = circlesize / earthSize;
    const ratioString = ratio.toFixed(1);
    const [integerPart, decimalPart] = ratioString.split(".");
    return integerPart + "." + decimalPart;
  }

  useEffect(() => {
    if (showText) {
      setTimeout(() => {
        setShowText(false);
      }, 2000);
    }
  }, [showText]);

  return (
    <>
      <div className="flex flex-col font-sen">
        <p className="text-base mb-1">Radius in km: {" " + value}</p>
        <div className="flex flex-row  max-w-md h-48 gap-6 w-full">
          <div className="w-full h-full bg-gray-dark flex py-4 px-8 justify-around items-end relative rounded-lg">
            {
              <div
                className="absolute top-2 left-2 text-gray-light !text-xs transition-all duration-500"
                style={{
                  opacity: showText ? 1 : 0,
                  transitionOpacity: "opacity 0.5s ease-in-out",
                }}
              >
                {calculateRatio()} earth
              </div>
            }
            <img
              src="/assets/images/earth.png"
              alt="Earth"
              style={{ width: `${earthSize}px`, height: `${earthSize}px` }}
            />
            <div
              className="rounded-full border-dotted border-2 border-white"
              style={{ width: `${circlesize}px`, height: `${circlesize}px` }}
            ></div>
          </div>
          <Slider
            size="md"
            step={10}
            maxValue={100000}
            minValue={500}
            value={value}
            onChange={changeSizeACB}
            onChangeEnd={(val) => {
              setShowText(true);
              onChange(val);
            }}
            orientation="vertical"
            aria-label="Temperature"
            defaultValue={0.2}
            color="foreground"
          />
        </div>
      </div>
    </>
  );
};

export default Size;
